import PKGDATA from '../../package.json';
//* should be available in PROD, otw use fallbacks.

// ------------------------------
export const APPDATA = {
  TITLE: PKGDATA.baseinfo.title
    || "Title not set",
  VERSION: PKGDATA.version
    || 'Ver Not Set',
  MODE: process.env.REACT_APP_MODE
    || process.env.NODE_ENV
    || 'Dev',
  NAME:
    PKGDATA.name.replace(/-/g, ' ')
      .replace(/(^\w{1})|(\s+\w{1})/g, (chr) => chr.toUpperCase())
    || 'App NAME Not Set',
  SUFFIX: PKGDATA.baseinfo.suffix
    || '',
  DESCRIPTION: PKGDATA.baseinfo.description
    || '',
  LICENSE: PKGDATA.license
    || 'UNLICENSED',
  COPYRIGHT: PKGDATA.baseinfo.copyright
    || 'All Rights Reserved',
  //  --- ENV ----
  WEBSITE: process.env.REACT_APP_WEBSITE
    || PKGDATA.baseinfo.homepageLive
    ||
    'App WEBSITE Not Set',
  SITECONTACT: process.env.REACT_APP_CONTACT
    || 'Site Contact Not Set',
  SITEEMAIL: process.env.REACT_APP_EMAIL
    || 'Site Contact Not Set',
  BACKEND: process.env.REACT_APP_BACKEND
    || '',
  // --- ROOT ---
  ROOT: window.location.origin
    || '',
  HOST: window.location.hostname
    || '',
  PORT: window.location.port
    || '',
  DEVELOPER: PKGDATA.baseinfo.developer //* is object!
    || '',
  SOCIAL: PKGDATA.baseinfo.social       //* is object!
    || '',
  REPO: {                               //* is object!
    github: PKGDATA.repository.page || 'App REPO Not Set',
    issues: PKGDATA.bugs.url || '',
    bugs: PKGDATA.bugs.email || ''
  },
  //  --- IMAGES ---
  IMAGES: {
    logo: '../assets/images/logo.svg'
      || '../assets/images/logo.png',
    bkgImg: '%PUBLIC_URL%/background.png',
    homeImg: '../assets/images/home.png',
    headerImg: '../assets/images/header.png',
    footerImg: '../assets/images/footer.png'
  }
};

export default APPDATA;
